import { createFileRoute } from '@tanstack/react-router'

import PublicSite from 'pages/PublicSite'

export const Route = createFileRoute('/public/sites/$id')({
  component: PublicSite,
})
